import { SampleFilters } from '@app/modules/service-data/services/sample.service';
import { ApiHeaders } from '@core/core.types';
import { ProvisionSample, Sample } from '../types/sample.types';

export const SAMPLES_NAME = 'Samples';
export class GetSamplesListAction {
  static type = `[${SAMPLES_NAME} GetSamplesListAction]`;

  constructor(
    public filters: SampleFilters,
    public headers: ApiHeaders,
    public pageToLoad: number,
    public reload: boolean
  ) {}
}
export class SetSamplesAction {
  static type = `[${SAMPLES_NAME} SetSamplesAction]`;

  constructor(
    public list: Sample[],
    public prependOnPage = false,
    public replaceId?: string
  ) {}
}
export class GetSampleAction {
  static type = `[${SAMPLES_NAME} GetSampleAction]`;

  constructor(
    public id: string,
    public prependToPage = false,
    public reload?: boolean,
    public replaceId?: string
  ) {}
}
export class CreateSampleAction {
  static type = `[${SAMPLES_NAME} CreateSampleAction]`;

  constructor(public sample: ProvisionSample) {}
}
export class UpdateSampleAction {
  static type = `[${SAMPLES_NAME} UpdateSampleAction]`;

  constructor(public sample: Sample) {}
}

export class RemoveSampleAction {
  static type = `[${SAMPLES_NAME} RemoveSampleAction]`;

  constructor(public sampleId: string) {}
}

export class ChangeSampleKitAction {
  static type = `[${SAMPLES_NAME} ChangeSampleKitAction]`;

  constructor(
    public sampleId: string,
    public kitId: string
  ) {}
}
